// extracted by mini-css-extract-plugin
export default {"modalOverlay":"jF-z","modalContent":"kF-z","header":"lF-z","close":"mF-z"};